import { Box } from '@mui/material';
import { styled } from '@mui/material';

export const StyledSumTableWrapper = styled(Box)(({ theme }) => ({
    border: `1px solid ${theme.palette.grey[300]}`,
    backgroundColor: theme.palette.grey[100],
    borderRadius: theme.spacing(0.5),
    paddingInline: theme.spacing(2),
}));
